import { InlineImage } from "../../components/InlineImage";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function DeBedriegers() {
  return (
    <div>
      <div className="box light">
        <div className="left">
          <h1>De Bedriegers (2024)</h1>
          <p>
            Voor een zomervakantie in Érezée in 2024 organiseerde ik voor de kinderen het spel "De Bedriegers". Dit spel is een kruising tussen "Wie is de Mol" en "De Verraders".
            Het voornaamste verschil zat hem in het uitgangspunt; waar bij de twee genoemde spelen tussentijds mensen naar huis moeten is dat natuurlijk met een groep mensen met
            wie je op vakantie bent geen optie. Uitgangspunt is dus dat alle kinderen het volledige spel tot en met het einde spelen en er niemand vroegtijdig afvalt.
          </p>
          <p>
            Voor dit spel had ik een eigen website gemaakt, met instructies voor alle begeleiders. Daardoor had ik tijdens de vakantie zelf minimale voorbereidingstijd nodig, zodat
            ik zelf ook nog een beetje vakantie kon vieren. Deze site vind je hier: <a href="https://ladagevandoorn.nl/debedriegers/index.php">Website De Bedriegers</a>
          </p>
          <p>
            De foto met alle deelnemers is van de eerste opdracht, waarbij de deelnemers de tram pakten van Érezée naar Forge à la Plez en onderweg allemaal vreemd geklede mensen
            moesten spotten.
          </p>
        </div>
        <div className="right">
          <InlineImage image="spellen/2024_debedriegers.jpg" subscript="Deelnemers De Bedriegers 2024" />
        </div>
      </div>
    </div>
  );
}

export default DeBedriegers;
